// @flow
import { CategoriasEnlacesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    categoriaEnlaces: {},
    listaCategoriasEnlaces: [],
    loading: false,
    error: false,
    formSubmited: false
};

type CategoriasEnlacesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { categoriaEnlaces?: {} | null, listaCategoriasEnlaces?: [] | null, loading?: boolean, +value ?: boolean };

const CategoriasEnlaces = (state: State = INIT_STATE, action: CategoriasEnlacesAction): any => {
    // console.log(action);
    switch (action.type) {
        case CategoriasEnlacesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case CategoriasEnlacesActionTypes.GET_CATEGORIA_ENLACES: {
                    return {
                        ...state,
                        categoriaEnlaces: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CategoriasEnlacesActionTypes.LIST_CATEGORIAS_ENLACES: {
                    return {
                        ...state,
                        listaCategoriasEnlaces: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CategoriasEnlacesActionTypes.ADD_CATEGORIA_ENLACES: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case CategoriasEnlacesActionTypes.UPDATE_CATEGORIA_ENLACES: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case CategoriasEnlacesActionTypes.DELETE_CATEGORIA_ENLACES: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CategoriasEnlacesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case CategoriasEnlacesActionTypes.GET_CATEGORIA_ENLACES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        categoriaEnlaces: {},
                        loading: false,
                    };
                }
                case CategoriasEnlacesActionTypes.LIST_CATEGORIAS_ENLACES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaCategoriasEnlaces: [],
                        loading: false,
                    };
                }
                case CategoriasEnlacesActionTypes.ADD_CATEGORIA_ENLACES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case CategoriasEnlacesActionTypes.UPDATE_CATEGORIA_ENLACES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case CategoriasEnlacesActionTypes.DELETE_CATEGORIA_ENLACES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CategoriasEnlacesActionTypes.GET_CATEGORIA_ENLACES:
            return { ...state, error: false, loading: true };
        case CategoriasEnlacesActionTypes.LIST_CATEGORIAS_ENLACES:
            return { ...state, error: false, loading: true };
        case CategoriasEnlacesActionTypes.ADD_CATEGORIA_ENLACES:
            return { ...state, error: false, loading: true };
        case CategoriasEnlacesActionTypes.UPDATE_CATEGORIA_ENLACES:
            return { ...state, error: false, loading: true };
        case CategoriasEnlacesActionTypes.DELETE_CATEGORIA_ENLACES:
            return { ...state, error: false, loading: true };
        case CategoriasEnlacesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                categoriaEnlaces: {},
                listaCategoriasEnlaces: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default CategoriasEnlaces;
